const VARIANTS = {
  green: "text-white bg-gradient-to-br from-brand-green to-[#3a9410] shadow-[0_10px_26px_rgba(76,175,24,0.45)] hover:-translate-y-0.5",
  orange: "text-white bg-gradient-to-br from-brand-orange to-[#e07a00] shadow-[0_10px_26px_rgba(247,148,29,0.5)] hover:-translate-y-0.5",
  ghost: "text-white bg-white/10 border border-white/35 backdrop-blur-sm hover:bg-white/20",
};

const GradientButton = ({ children, variant = "green", href, onClick, className = "", type = "button" }) => {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full px-7 py-3 font-semibold text-sm transition-all duration-200 ${VARIANTS[variant]} ${className}`;
  return href ? (
    <a href={href} onClick={onClick} className={cls}>{children}</a>
  ) : (
    <button type={type} onClick={onClick} className={cls}>{children}</button>
  );
};

export default GradientButton;
